/**
 * Created by daijiawei on 2016/10/29.
 */
// import * as actions from './actions'
// import * as getters from './getter'
// import { GET_REFLECT_LIST } from './mutation-type'

const state = {
  isLoading: false,
  direction: 'forward'
}
const mutations = {
  UPDATE_LOADING (state, status) {
    state.isLoading = status
  },
  UPDATE_DIRECTION (state, direction) {
    state.direction = direction
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/pages/store.js